import { $, $$ } from '../../../shared/js/utils/dom';
import { ListExpander } from './list-expander';

const expanders = $$('.list-expander--podcast');
const expanderInstances = [];

expanders.forEach(expander => {
  const listContainer = $('.list-expander__list', expander);
  const list = $(
    '.list-expander__list > ul, .list-expander__list > ol',
    expander
  );
  const handler = $('.list-expander__toggle', expander);
  // const toggleHandler = e => {
  //   e.preventDefault();
  //   expanderInstance.toggle();
  // };
  const expanderInstance = new ListExpander({ listContainer, list, handler });

  expanderInstances.push(expanderInstance);
  expanderInstance.init();

  // toggle.addEventListener('click', toggleHandler);
});
